import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

import api from "../api/api";
import { canManagePlanejamentos, getSession } from "../auth/session";
import MagmaSelect from "../components/MagmaSelect";
import "./PlanejamentoDetalhe.css";

const acaoStatusOptions = ["Nao Iniciado", "Em Andamento", "Concluido"];
const indicadorClassificacaoOptions = ["Qualitativo", "Quantitativo"];
const metaStatusOptions = ["Nao Iniciado", "Em Andamento", "Concluido"];
const statusLabels = {
  "Nao Iniciado": "Não Iniciado",
  "Em Andamento": "Em andamento",
  Concluido: "Concluído",
};

function isConcluida(value) {
  const normalized = String(value || "").trim().toLowerCase().replace("_", " ");
  return normalized === "concluido" || normalized === "concluida";
}

function formatValor(texto, numerico) {
  if (texto !== null && texto !== undefined && String(texto).trim() !== "") {
    return String(texto);
  }
  if (numerico !== null && numerico !== undefined && String(numerico).trim() !== "") {
    return String(numerico);
  }
  return "-";
}

function formatImpactoLabel(value) {
  if (value === "Medio") return "Médio";
  return value || "-";
}

function formatProbabilidadeLabel(value) {
  if (value === "Media") return "Média";
  return value || "-";
}

export default function PlanejamentoDetalhePage({ mode = "view" }) {
  const session = getSession();
  const canEdit = canManagePlanejamentos(session);
  const isAdminEditMode = mode === "edit" && canEdit;
  const { planejamentoId } = useParams();
  const location = useLocation();
  const routeState = location.state || {};
  const routeWorkspaceId = routeState.workspaceId;

  const [planejamento, setPlanejamento] = useState(routeState.planejamento || null);
  const [planejamentoNome, setPlanejamentoNome] = useState("");
  const [planejamentoDescricao, setPlanejamentoDescricao] = useState("");
  const [planejamentoStatusId, setPlanejamentoStatusId] = useState("1");
  const [workspaceName, setWorkspaceName] = useState("");
  const [eixos, setEixos] = useState([]);
  const [objetivosMap, setObjetivosMap] = useState({});
  const [acoesMap, setAcoesMap] = useState({});
  const [indicadores, setIndicadores] = useState([]);
  const [metas, setMetas] = useState([]);
  const [diagnosticos, setDiagnosticos] = useState([]);
  const [riscos, setRiscos] = useState([]);

  const [selectedEixoId, setSelectedEixoId] = useState("");
  const [selectedObjetivoId, setSelectedObjetivoId] = useState("");
  const [selectedAcaoId, setSelectedAcaoId] = useState("");
  const [selectedIndicadorId, setSelectedIndicadorId] = useState("");

  const [eixoNome, setEixoNome] = useState("");
  const [objetivoNome, setObjetivoNome] = useState("");

  const [acaoOQue, setAcaoOQue] = useState("");
  const [acaoPorQue, setAcaoPorQue] = useState("");
  const [acaoOnde, setAcaoOnde] = useState("");
  const [acaoQuem, setAcaoQuem] = useState("");
  const [acaoComo, setAcaoComo] = useState("");
  const [acaoQuando, setAcaoQuando] = useState("");
  const [acaoQuanto, setAcaoQuanto] = useState("");
  const [acaoStatus, setAcaoStatus] = useState("Nao Iniciado");

  const [indicadorNome, setIndicadorNome] = useState("");
  const [indicadorClassificacao, setIndicadorClassificacao] = useState("Qualitativo");
  const [indicadorValor, setIndicadorValor] = useState("");
  const [indicadorDNA, setIndicadorDNA] = useState("");

  const [metaNome, setMetaNome] = useState("");
  const [metaValor, setMetaValor] = useState("");
  const [metaStatus, setMetaStatus] = useState("Nao Iniciado");

  const [diagTitulo, setDiagTitulo] = useState("");
  const [diagDescricao, setDiagDescricao] = useState("");
  const [riscoObjetivoId, setRiscoObjetivoId] = useState("");
  const [riscoIdentificacao, setRiscoIdentificacao] = useState("");
  const [riscoCausa, setRiscoCausa] = useState("");
  const [riscoImpacto, setRiscoImpacto] = useState("Medio");
  const [riscoProbabilidade, setRiscoProbabilidade] = useState("Media");
  const [riscoPrevencao, setRiscoPrevencao] = useState("");
  const [riscoContingencia, setRiscoContingencia] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [editingEixoId, setEditingEixoId] = useState(null);
  const [editingObjetivoId, setEditingObjetivoId] = useState(null);
  const [editingAcaoId, setEditingAcaoId] = useState(null);
  const [editingIndicadorId, setEditingIndicadorId] = useState(null);
  const [editingMetaId, setEditingMetaId] = useState(null);
  const [editingDiagId, setEditingDiagId] = useState(null);
  const [editingRiscoId, setEditingRiscoId] = useState(null);

  const objetivosAtuais = useMemo(
    () => (selectedEixoId ? objetivosMap[selectedEixoId] || [] : []),
    [objetivosMap, selectedEixoId]
  );

  const acoesAtuais = useMemo(
    () => (selectedObjetivoId ? acoesMap[selectedObjetivoId] || [] : []),
    [acoesMap, selectedObjetivoId]
  );

  const indicadoresAtuais = useMemo(
    () => (selectedAcaoId ? indicadores.filter(item => String(item.acao_id) === String(selectedAcaoId)) : []),
    [indicadores, selectedAcaoId]
  );

  const allAcoes = useMemo(
    () => Object.values(acoesMap).flat(),
    [acoesMap]
  );
  const allObjetivos = useMemo(
    () => Object.values(objetivosMap).flat(),
    [objetivosMap]
  );

  const objetivosById = useMemo(() => {
    const map = {};
    allObjetivos.forEach(item => {
      map[String(item.id)] = item;
    });
    return map;
  }, [allObjetivos]);

  const acoesById = useMemo(() => {
    const map = {};
    allAcoes.forEach(item => {
      map[String(item.id)] = item;
    });
    return map;
  }, [allAcoes]);

  const eixosById = useMemo(() => {
    const map = {};
    eixos.forEach(item => {
      map[String(item.id)] = item;
    });
    return map;
  }, [eixos]);

  const indicadoresById = useMemo(() => {
    const map = {};
    indicadores.forEach(item => {
      map[String(item.id)] = item;
    });
    return map;
  }, [indicadores]);

  const loadPlanejamentoAndWorkspace = async () => {
    if (planejamento && routeWorkspaceId) {
      const wsRes = await api.get("/workspaces/");
      const ws = (wsRes.data || []).find(item => String(item.id) === String(routeWorkspaceId));
      if (ws) {
        setWorkspaceName(ws.nome);
      }
      return;
    }

    const wsRes = await api.get("/workspaces/");
    const workspaces = wsRes.data || [];
    for (const ws of workspaces) {
      const listRes = await api.get(`/planejamentos/workspaces/${ws.id}`);
      const found = (listRes.data || []).find(item => String(item.id) === String(planejamentoId));
      if (found) {
        setPlanejamento(found);
        setWorkspaceName(ws.nome);
        break;
      }
    }
  };

  const loadEstrutura = async () => {
    const bundleRes = await api.get(`/planejamento-estrutura/planejamentos/${planejamentoId}/bundle`);
    const bundle = bundleRes.data || {};

    const eixosData = bundle.eixos || [];
    const objetivosData = bundle.objetivos || [];
    const acoesData = bundle.acoes || [];
    const indicadoresData = bundle.indicadores || [];
    const metasData = bundle.metas || [];

    setEixos(eixosData);
    setDiagnosticos(bundle.diagnosticos || []);
    setRiscos(bundle.riscos || []);

    const objetivosByEixo = {};
    eixosData.forEach(eixo => {
      objetivosByEixo[eixo.id] = objetivosData.filter(item => String(item.eixo_id) === String(eixo.id));
    });

    const acoesByObjetivo = {};
    objetivosData.forEach(objetivo => {
      acoesByObjetivo[objetivo.id] = acoesData.filter(item => String(item.objetivo_id) === String(objetivo.id));
    });

    const acoesByIdMap = {};
    acoesData.forEach(item => {
      acoesByIdMap[String(item.id)] = item;
    });

    const indicadoresByIdMap = {};
    indicadoresData.forEach(item => {
      indicadoresByIdMap[String(item.id)] = item;
    });

    const indicadoresAll = indicadoresData.map(item => ({
      ...item,
      acao_nome: acoesByIdMap[String(item.acao_id)]?.o_que || "-",
    }));

    const metasAll = metasData.map(item => {
      const indicador = indicadoresByIdMap[String(item.indicador_id)];
      const acao = indicador ? acoesByIdMap[String(indicador.acao_id)] : null;
      return {
        ...item,
        acao_id: indicador?.acao_id,
        acao_nome: acao?.o_que || "-",
        indicador_nome: indicador?.nome || "-",
      };
    });

    setObjetivosMap(objetivosByEixo);
    setAcoesMap(acoesByObjetivo);
    setIndicadores(indicadoresAll);
    setMetas(metasAll);

    if (eixosData.length > 0) {
      const eixoId = String(eixosData[0].id);
      setSelectedEixoId(prev => prev || eixoId);
      const objetivosPrimeiro = objetivosByEixo[eixosData[0].id] || [];
      if (objetivosPrimeiro.length > 0) {
        const objetivoId = String(objetivosPrimeiro[0].id);
        setSelectedObjetivoId(prev => prev || objetivoId);
        setRiscoObjetivoId(prev => prev || objetivoId);
        const acoesPrimeiro = acoesByObjetivo[objetivosPrimeiro[0].id] || [];
        if (acoesPrimeiro.length > 0) {
          const firstAcaoId = String(acoesPrimeiro[0].id);
          setSelectedAcaoId(prev => prev || firstAcaoId);
          const indPrimeiros = indicadoresAll.filter(item => String(item.acao_id) === firstAcaoId);
          if (indPrimeiros.length > 0) {
            setSelectedIndicadorId(prev => prev || String(indPrimeiros[0].id));
          }
        }
      }
    }
  };

  const refreshAll = async () => {
    try {
      setLoading(true);
      setError("");
      await loadEstrutura();
    } catch (err) {
      setError(err.response.data.detail || "Falha ao carregar estrutura.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        setLoading(true);
        await loadPlanejamentoAndWorkspace();
        await loadEstrutura();
      } catch (err) {
        setError(err.response.data.detail || "Falha ao carregar planejamento.");
      } finally {
        setLoading(false);
      }
    };
    init();
  }, [planejamentoId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!planejamento) {
      setPlanejamentoNome("");
      setPlanejamentoDescricao("");
      setPlanejamentoStatusId("1");
      return;
    }
    setPlanejamentoNome(planejamento.nome || "");
    setPlanejamentoDescricao(planejamento.descricao || "");
    setPlanejamentoStatusId(String(planejamento.status_id || 1));
  }, [planejamento]);

  const handleSavePlanejamento = async () => {
    if (!isAdminEditMode || !planejamentoId) return;
    if (!planejamentoNome.trim()) {
      setError("Nome do planejamento é obrigatório.");
      return;
    }

    try {
      setLoading(true);
      setError("");
      const payload = {
        nome: planejamentoNome.trim(),
        descricao: planejamentoDescricao.trim() ? planejamentoDescricao.trim() : null,
        status_id: Number(planejamentoStatusId || 1),
      };
      const res = await api.put(`/planejamentos/${planejamentoId}`, payload);
      const updated = res.data || { ...(planejamento || {}), ...payload };
      setPlanejamento(updated);
    } catch (err) {
      setError(err?.response?.data?.detail || "Erro ao salvar dados do planejamento.");
    } finally {
      setLoading(false);
    }
  };

  const handleApi = async fn => {
    try {
      setError("");
      await fn();
      await refreshAll();
    } catch (err) {
      setError(err.response.data.detail || "Erro ao executar operação.");
    }
  };

  const badges = useMemo(() => {
    const acoesComPrazo = allAcoes.filter(acao => acao.quando);
    const prazoDasAcoesCumprido =
      acoesComPrazo.length > 0 &&
      acoesComPrazo.every(acao => isConcluida(acao.status));

    const todasAcoesConcluidas = allAcoes.length > 0 && allAcoes.every(acao => isConcluida(acao.status));
    const planejamentoConcluido = metas.length > 0 && metas.every(meta => isConcluida(meta.status));

    return [
      prazoDasAcoesCumprido ? "Prazo das ações cumprido" : null,
      todasAcoesConcluidas ? "Todas as ações concluídas" : null,
      planejamentoConcluido ? "Planejamento concluído" : null,
    ].filter(Boolean);
  }, [allAcoes, metas]);

  const clearEixoForm = () => {
    setEixoNome("");
    setEditingEixoId(null);
  };

  const clearObjetivoForm = () => {
    setObjetivoNome("");
    setEditingObjetivoId(null);
  };

  const clearAcaoForm = () => {
    setAcaoOQue("");
    setAcaoPorQue("");
    setAcaoOnde("");
    setAcaoQuem("");
    setAcaoComo("");
    setAcaoQuando("");
    setAcaoQuanto("");
    setAcaoStatus("Nao Iniciado");
    setEditingAcaoId(null);
  };

  const clearIndicadorForm = () => {
    setIndicadorNome("");
    setIndicadorClassificacao("Qualitativo");
    setIndicadorValor("");
    setIndicadorDNA("");
    setEditingIndicadorId(null);
  };

  const clearMetaForm = () => {
    setMetaNome("");
    setMetaValor("");
    setMetaStatus("Nao Iniciado");
    setEditingMetaId(null);
  };

  const clearDiagnosticoForm = () => {
    setDiagTitulo("");
    setDiagDescricao("");
    setEditingDiagId(null);
  };

  const clearRiscoForm = () => {
    setRiscoObjetivoId(selectedObjetivoId || "");
    setRiscoIdentificacao("");
    setRiscoCausa("");
    setRiscoImpacto("Medio");
    setRiscoProbabilidade("Media");
    setRiscoPrevencao("");
    setRiscoContingencia("");
    setEditingRiscoId(null);
  };

  return (
    <main className="plan-view-page">
      <header className="plan-view-header">
        <p className="plan-view-kicker">Planejamento</p>
        <h1 className="plan-view-title">{planejamento?.nome || `Planejamento ${planejamentoId}`}</h1>
        <p className="plan-view-subtitle">
          Workspace: {workspaceName || "Não identificado"}
        </p>
      </header>

      {loading ? <p>Carregando...</p> : null}
      {error ? <p className="plan-view-error">{error}</p> : null}

      <section className="plan-view-grid">
        <article className="plan-view-card plan-span-full">
          <h2>Dados do planejamento</h2>
          {isAdminEditMode ? (
            <div className="plan-inline-form">
              <label className="plan-label" htmlFor="planejamento-nome">Nome do planejamento</label>
              <input
                id="planejamento-nome"
                className="plan-input"
                value={planejamentoNome}
                onChange={e => setPlanejamentoNome(e.target.value)}
                placeholder="Nome do planejamento"
              />
              <label className="plan-label" htmlFor="planejamento-descricao">Descrição</label>
              <input
                id="planejamento-descricao"
                className="plan-input"
                value={planejamentoDescricao}
                onChange={e => setPlanejamentoDescricao(e.target.value)}
                placeholder="Descrição"
              />
              <label className="plan-label" htmlFor="planejamento-status">Status</label>
              <MagmaSelect
                id="planejamento-status"
                className="plan-select"
                value={planejamentoStatusId}
                onChange={e => setPlanejamentoStatusId(e.target.value)}
              >
                <option value="1">Rascunho</option>
                <option value="2">Em execução</option>
                <option value="3">Finalizado</option>
              </MagmaSelect>
              <button className="plan-btn" type="button" onClick={handleSavePlanejamento} disabled={loading}>
                Salvar dados
              </button>
            </div>
          ) : (
            <>
              <p><strong>Nome:</strong> {planejamento?.nome || "-"}</p>
              <p><strong>Descrição:</strong> {planejamento?.descricao || "-"}</p>
              <p><strong>Status:</strong> {statusLabels[planejamento?.status_id] || `Status ${planejamento?.status_id || "-"}`}</p>
            </>
          )}
        </article>
      </section>

      {isAdminEditMode ? ( <section className="plan-admin-grid">
        <article className="plan-admin-card">
          <h3>Eixos</h3>
          <div className="plan-inline-form">
            <label className="plan-label" htmlFor="eixo-nome">Nome do eixo</label>
            <input id="eixo-nome" className="plan-input" value={eixoNome} onChange={e => setEixoNome(e.target.value)} placeholder="Nome do eixo" />
            <button
              className="plan-btn"
              type="button"
              onClick={() => handleApi(async () => {
                if (editingEixoId) {
                  await api.put(`/planejamento-estrutura/eixos/${editingEixoId}`, { nome: eixoNome });
                } else {
                  await api.post(`/planejamento-estrutura/planejamentos/${planejamentoId}/eixos`, { nome: eixoNome });
                }
                clearEixoForm();
              })}
            >
              {editingEixoId ? "Salvar" : "Criar"}
            </button>
            {editingEixoId ? ( <button className="plan-btn" type="button" onClick={clearEixoForm}>Cancelar</button>
            ) : null}
          </div>
          <ul className="plan-list">
            {eixos.map(item => ( <li key={item.id} className="plan-item">
                <button className="plan-link-btn" type="button" onClick={() => setSelectedEixoId(String(item.id))}>{item.nome}</button>
                <div className="plan-item-actions">
                  <button className="plan-link-btn" type="button" onClick={() => {
                    setEditingEixoId(item.id);
                    setEixoNome(item.nome || "");
                  }}>Editar</button>
                  <button className="plan-link-btn danger" type="button" onClick={() => handleApi(async () => {
                    if (!window.confirm("Excluir eixo")) return;
                    await api.delete(`/planejamento-estrutura/eixos/${item.id}`);
                    if (editingEixoId === item.id) {
                      clearEixoForm();
                    }
                  })}>Excluir</button>
                </div>
              </li>
            ))}
          </ul>
        </article>

        <article className="plan-admin-card">
          <h3>Objetivos</h3>
          <div className="plan-inline-form">
            <label className="plan-label" htmlFor="objetivo-eixo">Eixo</label>
            <MagmaSelect id="objetivo-eixo" className="plan-select" value={selectedEixoId} onChange={e => setSelectedEixoId(e.target.value)}>
              <option value="">Selecione eixo</option>
              {eixos.map(item => <option key={item.id} value={item.id}>{item.nome}</option>)}
            </MagmaSelect>
            <label className="plan-label" htmlFor="objetivo-nome">Nome do objetivo</label>
            <input id="objetivo-nome" className="plan-input" value={objetivoNome} onChange={e => setObjetivoNome(e.target.value)} placeholder="Nome do objetivo" />
            <button
              className="plan-btn"
              type="button"
              onClick={() => handleApi(async () => {
                if (!selectedEixoId) return;
                if (editingObjetivoId) {
                  await api.put(`/planejamento-estrutura/objetivos/${editingObjetivoId}`, { nome: objetivoNome });
                } else {
                  await api.post(`/planejamento-estrutura/eixos/${selectedEixoId}/objetivos`, { nome: objetivoNome });
                }
                clearObjetivoForm();
              })}
            >
              {editingObjetivoId ? "Salvar" : "Criar"}
            </button>
            {editingObjetivoId ? ( <button className="plan-btn" type="button" onClick={clearObjetivoForm}>Cancelar</button>
            ) : null}
          </div>
          <ul className="plan-list">
            {objetivosAtuais.map(item => ( <li key={item.id} className="plan-item">
                <button className="plan-link-btn" type="button" onClick={() => setSelectedObjetivoId(String(item.id))}>{item.nome}</button>
                <div className="plan-item-actions">
                  <button className="plan-link-btn" type="button" onClick={() => {
                    setEditingObjetivoId(item.id);
                    setSelectedEixoId(String(item.eixo_id));
                    setObjetivoNome(item.nome || "");
                  }}>Editar</button>
                  <button className="plan-link-btn danger" type="button" onClick={() => handleApi(async () => {
                    if (!window.confirm("Excluir objetivo")) return;
                    await api.delete(`/planejamento-estrutura/objetivos/${item.id}`);
                    if (editingObjetivoId === item.id) {
                      clearObjetivoForm();
                    }
                  })}>Excluir</button>
                </div>
              </li>
            ))}
          </ul>
        </article>

        <article className="plan-admin-card">
          <h3>Ações</h3>
          <div className="plan-inline-form">
            <label className="plan-label" htmlFor="acao-objetivo">Objetivo</label>
            <MagmaSelect id="acao-objetivo" className="plan-select" value={selectedObjetivoId} onChange={e => setSelectedObjetivoId(e.target.value)}>
              <option value="">Selecione objetivo</option>
              {objetivosAtuais.map(item => <option key={item.id} value={item.id}>{item.nome}</option>)}
            </MagmaSelect>
            <label className="plan-label" htmlFor="acao-oque">O que</label>
            <input id="acao-oque" className="plan-input" value={acaoOQue} onChange={e => setAcaoOQue(e.target.value)} placeholder="O que será feito" />
            <label className="plan-label" htmlFor="acao-porque">Por que</label>
            <input id="acao-porque" className="plan-input" value={acaoPorQue} onChange={e => setAcaoPorQue(e.target.value)} placeholder="Motivo da ação" />
            <label className="plan-label" htmlFor="acao-onde">Onde</label>
            <input id="acao-onde" className="plan-input" value={acaoOnde} onChange={e => setAcaoOnde(e.target.value)} placeholder="Local da execução" />
            <label className="plan-label" htmlFor="acao-quem">Quem</label>
            <input id="acao-quem" className="plan-input" value={acaoQuem} onChange={e => setAcaoQuem(e.target.value)} placeholder="Responsável" />
            <label className="plan-label" htmlFor="acao-como">Como</label>
            <input id="acao-como" className="plan-input" value={acaoComo} onChange={e => setAcaoComo(e.target.value)} placeholder="Forma de execução" />
            <label className="plan-label" htmlFor="acao-quando">Quando</label>
            <input id="acao-quando" className="plan-input" value={acaoQuando} onChange={e => setAcaoQuando(e.target.value)} placeholder="Prazo/data prevista" />
            <label className="plan-label" htmlFor="acao-quanto">Quanto</label>
            <input id="acao-quanto" className="plan-input" value={acaoQuanto} onChange={e => setAcaoQuanto(e.target.value)} placeholder="Custo/estimativa" />
            <label className="plan-label" htmlFor="acao-status">Status</label>
            <MagmaSelect id="acao-status" className="plan-select" value={acaoStatus} onChange={e => setAcaoStatus(e.target.value)}>
              {acaoStatusOptions.map(item => <option key={item} value={item}>{statusLabels[item] || item}</option>)}
            </MagmaSelect>
            <button
              className="plan-btn"
              type="button"
              onClick={() => handleApi(async () => {
                if (!selectedObjetivoId) return;
                const payload = {
                  o_que: acaoOQue,
                  por_que: acaoPorQue || null,
                  onde: acaoOnde || null,
                  quem: acaoQuem || null,
                  como: acaoComo || null,
                  quando: acaoQuando || null,
                  quanto: acaoQuanto || null,
                  status: acaoStatus,
                };
                if (editingAcaoId) {
                  await api.put(`/planejamento-estrutura/acoes/${editingAcaoId}`, payload);
                } else {
                  await api.post(`/planejamento-estrutura/objetivos/${selectedObjetivoId}/acoes`, payload);
                }
                clearAcaoForm();
              })}
            >
              {editingAcaoId ? "Salvar" : "Criar"}
            </button>
            {editingAcaoId ? ( <button className="plan-btn" type="button" onClick={clearAcaoForm}>Cancelar</button>
            ) : null}
          </div>
          <ul className="plan-list">
            {acoesAtuais.map(item => ( <li key={item.id} className="plan-item">
                <button
                  className="plan-link-btn"
                  type="button"
                  onClick={() => {
                    const acaoId = String(item.id);
                    setSelectedAcaoId(acaoId);
                    const firstIndicador = indicadores.find(ind => String(ind.acao_id) === acaoId);
                    if (firstIndicador) {
                      setSelectedIndicadorId(String(firstIndicador.id));
                    }
                  }}
                >
                  {item.o_que} | Quem: {item.quem || "-"} | Quando: {item.quando || "-"} | Quanto: {item.quanto || "-"} | {statusLabels[item.status] || item.status}
                </button>
                <div className="plan-item-actions">
                  <button className="plan-link-btn" type="button" onClick={() => {
                    setEditingAcaoId(item.id);
                    setSelectedObjetivoId(String(item.objetivo_id));
                    setAcaoOQue(item.o_que || "");
                    setAcaoPorQue(item.por_que || "");
                    setAcaoOnde(item.onde || "");
                    setAcaoQuem(item.quem || "");
                    setAcaoComo(item.como || "");
                    setAcaoQuando(item.quando || "");
                    setAcaoQuanto(item.quanto || "");
                    setAcaoStatus(item.status || "Nao Iniciado");
                  }}>Editar</button>
                  <button className="plan-link-btn danger" type="button" onClick={() => handleApi(async () => {
                    if (!window.confirm("Excluir ação")) return;
                    await api.delete(`/planejamento-estrutura/acoes/${item.id}`);
                    if (editingAcaoId === item.id) {
                      clearAcaoForm();
                    }
                  })}>Excluir</button>
                </div>
              </li>
            ))}
          </ul>
        </article>

        <article className="plan-admin-card">
          <h3>Indicadores</h3>
          <div className="plan-inline-form">
            <label className="plan-label" htmlFor="indicador-acao">Ação</label>
            <MagmaSelect
              id="indicador-acao"
              className="plan-select"
              value={selectedAcaoId}
              onChange={e => {
                const acaoId = e.target.value;
                setSelectedAcaoId(acaoId);
                const firstIndicador = indicadores.find(ind => String(ind.acao_id) === String(acaoId));
                setSelectedIndicadorId(firstIndicador ? String(firstIndicador.id) : "");
              }}
            >
              <option value="">Selecione ação</option>
              {acoesAtuais.map(item => <option key={item.id} value={item.id}>{item.o_que}</option>)}
            </MagmaSelect>
            <label className="plan-label" htmlFor="indicador-nome">Nome do indicador</label>
            <input id="indicador-nome" className="plan-input" value={indicadorNome} onChange={e => setIndicadorNome(e.target.value)} placeholder="Nome do indicador" />
            <label className="plan-label" htmlFor="indicador-classificacao">Classificação</label>
            <MagmaSelect id="indicador-classificacao" className="plan-select" value={indicadorClassificacao} onChange={e => setIndicadorClassificacao(e.target.value)}>
              {indicadorClassificacaoOptions.map(item => <option key={item} value={item}>{item}</option>)}
            </MagmaSelect>
            <label className="plan-label" htmlFor="indicador-valor">Valor</label>
            <input
              id="indicador-valor"
              className="plan-input"
              type={indicadorClassificacao === "Quantitativo" ? "number" : "text"}
              step="any"
              value={indicadorValor}
              onChange={e => setIndicadorValor(e.target.value)}
              placeholder={indicadorClassificacao === "Quantitativo" ? "Valor numérico" : "Valor qualitativo"}
            />
            <label className="plan-label" htmlFor="indicador-dna">DNA</label>
            <input id="indicador-dna" className="plan-input" value={indicadorDNA} onChange={e => setIndicadorDNA(e.target.value)} placeholder="DNA" />
            <button
              className="plan-btn"
              type="button"
              onClick={() => handleApi(async () => {
                if (!selectedAcaoId) return;
                const payload = {
                  nome: indicadorNome,
                  classificacao: indicadorClassificacao,
                  dna: indicadorDNA || null,
                  valor_texto: indicadorClassificacao === "Qualitativo" ? (indicadorValor || null) : null,
                  valor_numerico: indicadorClassificacao === "Quantitativo" ? Number(indicadorValor || 0) : null,
                };
                if (editingIndicadorId) {
                  await api.put(`/planejamento-estrutura/indicadores/${editingIndicadorId}`, payload);
                } else {
                  await api.post(`/planejamento-estrutura/acoes/${selectedAcaoId}/indicadores`, payload);
                }
                clearIndicadorForm();
              })}
            >
              {editingIndicadorId ? "Salvar" : "Criar"}
            </button>
            {editingIndicadorId ? ( <button className="plan-btn" type="button" onClick={clearIndicadorForm}>Cancelar</button>
            ) : null}
          </div>
          <ul className="plan-list">
            {indicadoresAtuais.map(item => ( <li key={item.id} className="plan-item">
                <button className="plan-link-btn" type="button" onClick={() => setSelectedIndicadorId(String(item.id))}>
                  {item.nome} | {item.classificacao} | Valor: {formatValor(item.valor_texto, item.valor_numerico)} | DNA: {item.dna || "-"}
                </button>
                <div className="plan-item-actions">
                  <button className="plan-link-btn" type="button" onClick={() => {
                    setEditingIndicadorId(item.id);
                    setSelectedAcaoId(String(item.acao_id));
                    setSelectedIndicadorId(String(item.id));
                    setIndicadorNome(item.nome || "");
                    setIndicadorClassificacao(item.classificacao || "Qualitativo");
                    setIndicadorValor(String(item.valor_texto ?? item.valor_numerico ?? ""));
                    setIndicadorDNA(item.dna || "");
                  }}>Editar</button>
                  <button className="plan-link-btn danger" type="button" onClick={() => handleApi(async () => {
                    if (!window.confirm("Excluir indicador")) return;
                    await api.delete(`/planejamento-estrutura/indicadores/${item.id}`);
                    if (editingIndicadorId === item.id) {
                      clearIndicadorForm();
                    }
                  })}>Excluir</button>
                </div>
              </li>
            ))}
          </ul>
        </article>

        <article className="plan-admin-card">
          <h3>Metas</h3>
          <div className="plan-inline-form">
            <label className="plan-label" htmlFor="meta-indicador">Indicador</label>
            <MagmaSelect id="meta-indicador" className="plan-select" value={selectedIndicadorId} onChange={e => setSelectedIndicadorId(e.target.value)}>
              <option value="">Selecione indicador</option>
              {indicadoresAtuais.map(item => <option key={item.id} value={item.id}>{item.nome}</option>)}
            </MagmaSelect>
            <label className="plan-label" htmlFor="meta-nome">Nome da meta</label>
            <input id="meta-nome" className="plan-input" value={metaNome} onChange={e => setMetaNome(e.target.value)} placeholder="Nome da meta" />
            <label className="plan-label" htmlFor="meta-valor">Valor</label>
            <input
              id="meta-valor"
              className="plan-input"
              type={(indicadores.find(ind => String(ind.id) === String(selectedIndicadorId))?.classificacao || "Qualitativo") === "Quantitativo" ? "number" : "text"}
              step="any"
              value={metaValor}
              onChange={e => setMetaValor(e.target.value)}
              placeholder="Valor da meta"
            />
            <label className="plan-label" htmlFor="meta-status">Status</label>
            <MagmaSelect id="meta-status" className="plan-select" value={metaStatus} onChange={e => setMetaStatus(e.target.value)}>
              {metaStatusOptions.map(item => <option key={item} value={item}>{statusLabels[item] || item}</option>)}
            </MagmaSelect>
            <button
              className="plan-btn"
              type="button"
              onClick={() => handleApi(async () => {
                if (!selectedIndicadorId) return;
                const indicadorAtualMeta = indicadores.find(ind => String(ind.id) === String(selectedIndicadorId));
                const payload = {
                  indicador_id: Number(selectedIndicadorId),
                  nome: metaNome,
                  status: metaStatus,
                  valor_texto: (indicadorAtualMeta?.classificacao || "Qualitativo") === "Qualitativo" ? (metaValor || null) : null,
                  valor_numerico: (indicadorAtualMeta?.classificacao || "Qualitativo") === "Quantitativo" ? Number(metaValor || 0) : null,
                };
                if (editingMetaId) {
                  await api.put(`/planejamento-estrutura/metas/${editingMetaId}`, payload);
                } else {
                  await api.post(`/planejamento-estrutura/indicadores/${selectedIndicadorId}/metas`, payload);
                }
                clearMetaForm();
              })}
            >
              {editingMetaId ? "Salvar" : "Criar"}
            </button>
            {editingMetaId ? ( <button className="plan-btn" type="button" onClick={clearMetaForm}>Cancelar</button>
            ) : null}
          </div>
          <ul className="plan-list">
            {metas.filter(item => String(item.indicador_id) === String(selectedIndicadorId)).map(item => ( <li key={item.id} className="plan-item">
                <span>{item.nome} | Valor: {formatValor(item.valor_texto, item.valor_numerico)} | {statusLabels[item.status] || item.status}</span>
                <div className="plan-item-actions">
                  <button className="plan-link-btn" type="button" onClick={() => {
                    setEditingMetaId(item.id);
                    setSelectedIndicadorId(String(item.indicador_id));
                    setMetaNome(item.nome || "");
                    setMetaValor(String(item.valor_texto ?? item.valor_numerico ?? ""));
                    setMetaStatus(item.status || "Nao Iniciado");
                  }}>Editar</button>
                  <button className="plan-link-btn danger" type="button" onClick={() => handleApi(async () => {
                    if (!window.confirm("Excluir meta")) return;
                    await api.delete(`/planejamento-estrutura/metas/${item.id}`);
                    if (editingMetaId === item.id) {
                      clearMetaForm();
                    }
                  })}>Excluir</button>
                </div>
              </li>
            ))}
          </ul>
        </article>

        <article className="plan-admin-card">
          <h3>Diagnósticos</h3>
          <div className="plan-inline-form">
            <label className="plan-label" htmlFor="diag-titulo">Título</label>
            <input id="diag-titulo" className="plan-input" value={diagTitulo} onChange={e => setDiagTitulo(e.target.value)} placeholder="Título" />
            <label className="plan-label" htmlFor="diag-descricao">Descrição</label>
            <input id="diag-descricao" className="plan-input" value={diagDescricao} onChange={e => setDiagDescricao(e.target.value)} placeholder="Descrição" />
            <button
              className="plan-btn"
              type="button"
              onClick={() => handleApi(async () => {
                if (editingDiagId) {
                  await api.put(`/planejamento-estrutura/diagnosticos/${editingDiagId}`, {
                    titulo: diagTitulo,
                    descricao: diagDescricao,
                  });
                } else {
                  await api.post(`/planejamento-estrutura/planejamentos/${planejamentoId}/diagnosticos`, {
                    titulo: diagTitulo,
                    descricao: diagDescricao,
                  });
                }
                clearDiagnosticoForm();
              })}
            >
              {editingDiagId ? "Salvar" : "Criar"}
            </button>
            {editingDiagId ? ( <button className="plan-btn" type="button" onClick={clearDiagnosticoForm}>Cancelar</button>
            ) : null}
          </div>
          <ul className="plan-list">
            {diagnosticos.map(item => ( <li key={item.id} className="plan-item">
                <span>{item.titulo}</span>
                <div className="plan-item-actions">
                  <button className="plan-link-btn" type="button" onClick={() => {
                    setEditingDiagId(item.id);
                    setDiagTitulo(item.titulo || "");
                    setDiagDescricao(item.descricao || "");
                  }}>Editar</button>
                  <button className="plan-link-btn danger" type="button" onClick={() => handleApi(async () => {
                    if (!window.confirm("Excluir diagnóstico")) return;
                    await api.delete(`/planejamento-estrutura/diagnosticos/${item.id}`);
                    if (editingDiagId === item.id) {
                      clearDiagnosticoForm();
                    }
                  })}>Excluir</button>
                </div>
              </li>
            ))}
          </ul>
        </article>

        <article className="plan-admin-card">
          <h3>Riscos</h3>
          <div className="plan-inline-form">
            <label className="plan-label" htmlFor="risco-objetivo">Objetivo</label>
            <MagmaSelect id="risco-objetivo" className="plan-select" value={riscoObjetivoId} onChange={e => setRiscoObjetivoId(e.target.value)}>
              <option value="">Selecione objetivo</option>
              {allObjetivos.map(item => <option key={item.id} value={item.id}>{item.nome}</option>)}
            </MagmaSelect>
            <label className="plan-label" htmlFor="risco-identificacao">Identificação do risco</label>
            <input id="risco-identificacao" className="plan-input" value={riscoIdentificacao} onChange={e => setRiscoIdentificacao(e.target.value)} placeholder="Identificação do risco" />
            <label className="plan-label" htmlFor="risco-causa">Causa do risco</label>
            <input id="risco-causa" className="plan-input" value={riscoCausa} onChange={e => setRiscoCausa(e.target.value)} placeholder="Causa do risco" />
            <label className="plan-label" htmlFor="risco-impacto">Impacto</label>
            <MagmaSelect id="risco-impacto" className="plan-select" value={riscoImpacto} onChange={e => setRiscoImpacto(e.target.value)}>
              <option value="Baixo">Baixo</option>
              <option value="Medio">Médio</option>
              <option value="Alto">Alto</option>
            </MagmaSelect>
            <label className="plan-label" htmlFor="risco-probabilidade">Probabilidade</label>
            <MagmaSelect id="risco-probabilidade" className="plan-select" value={riscoProbabilidade} onChange={e => setRiscoProbabilidade(e.target.value)}>
              <option value="Baixa">Baixa</option>
              <option value="Media">Média</option>
              <option value="Alta">Alta</option>
            </MagmaSelect>
            <label className="plan-label" htmlFor="risco-prevencao">Prevenção</label>
            <input id="risco-prevencao" className="plan-input" value={riscoPrevencao} onChange={e => setRiscoPrevencao(e.target.value)} placeholder="Plano de prevenção" />
            <label className="plan-label" htmlFor="risco-contingencia">Contingência</label>
            <input id="risco-contingencia" className="plan-input" value={riscoContingencia} onChange={e => setRiscoContingencia(e.target.value)} placeholder="Plano de contingência" />
            <button
              className="plan-btn"
              type="button"
              onClick={() => handleApi(async () => {
                if (!riscoObjetivoId) return;
                if (editingRiscoId) {
                  await api.put(`/planejamento-estrutura/riscos/${editingRiscoId}`, {
                    objetivo_id: Number(riscoObjetivoId),
                    identificacao: riscoIdentificacao,
                    causa: riscoCausa,
                    impacto: riscoImpacto,
                    probabilidade: riscoProbabilidade,
                    prevencao: riscoPrevencao,
                    contingencia: riscoContingencia,
                  });
                } else {
                  await api.post(`/planejamento-estrutura/planejamentos/${planejamentoId}/riscos`, {
                    objetivo_id: Number(riscoObjetivoId),
                    identificacao: riscoIdentificacao,
                    causa: riscoCausa,
                    impacto: riscoImpacto,
                    probabilidade: riscoProbabilidade,
                    prevencao: riscoPrevencao,
                    contingencia: riscoContingencia,
                  });
                }
                clearRiscoForm();
              })}
            >
              {editingRiscoId ? "Salvar" : "Criar"}
            </button>
            {editingRiscoId ? ( <button className="plan-btn" type="button" onClick={clearRiscoForm}>Cancelar</button>
            ) : null}
          </div>
          <ul className="plan-list">
            {riscos.map(item => ( <li key={item.id} className="plan-item">
                <span>{item.identificacao} | {objetivosById[String(item.objetivo_id)]?.nome || "-"} ({formatImpactoLabel(item.impacto)}/{formatProbabilidadeLabel(item.probabilidade)})</span>
                <div className="plan-item-actions">
                  <button className="plan-link-btn" type="button" onClick={() => {
                    setEditingRiscoId(item.id);
                    setRiscoObjetivoId(String(item.objetivo_id || ""));
                    setRiscoIdentificacao(item.identificacao || "");
                    setRiscoCausa(item.causa || "");
                    setRiscoImpacto(item.impacto || "Medio");
                    setRiscoProbabilidade(item.probabilidade || "Media");
                    setRiscoPrevencao(item.prevencao || "");
                    setRiscoContingencia(item.contingencia || "");
                  }}>Editar</button>
                  <button className="plan-link-btn danger" type="button" onClick={() => handleApi(async () => {
                    if (!window.confirm("Excluir risco")) return;
                    await api.delete(`/planejamento-estrutura/riscos/${item.id}`);
                    if (editingRiscoId === item.id) {
                      clearRiscoForm();
                    }
                  })}>Excluir</button>
                </div>
              </li>
            ))}
          </ul>
        </article>

        <article className="plan-admin-card">
          <h3>Overview</h3>
          <div className="plan-badges">
            {badges.length > 0 ? badges.map(badge => ( <span key={badge} className="plan-badge">{badge}</span>
            )) : <span className="plan-badge">Sem badges por enquanto</span>}
          </div>
          <ul>
            <li>{allAcoes.length} ações totais</li>
            <li>{allAcoes.filter(acao => isConcluida(acao.status)).length} ações concluídas</li>
            <li>{metas.filter(meta => isConcluida(meta.status)).length}/{metas.length} metas concluídas</li>
          </ul>
        </article>
      </section>
      ) : (
        <section className="plan-admin-grid">
          <article className="plan-admin-card">
            <h3>Eixos</h3>
            <table className="plan-view-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nome</th>
                </tr>
              </thead>
              <tbody>
                {eixos.map(item => ( <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.nome}</td>
                  </tr>
                ))}
                {eixos.length === 0 ? ( <tr><td colSpan="2">Sem eixos cadastrados.</td></tr>
                ) : null}
              </tbody>
            </table>
          </article>

          <article className="plan-admin-card">
            <h3>Objetivos</h3>
            <table className="plan-view-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Eixo</th>
                  <th>Nome</th>
                </tr>
              </thead>
              <tbody>
                {allObjetivos.map(item => ( <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{eixosById[String(item.eixo_id)]?.nome || "-"}</td>
                    <td>{item.nome}</td>
                  </tr>
                ))}
                {allObjetivos.length === 0 ? ( <tr><td colSpan="3">Sem objetivos cadastrados.</td></tr>
                ) : null}
              </tbody>
            </table>
          </article>

          <article className="plan-admin-card">
            <h3>Ações</h3>
            <table className="plan-view-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Objetivo</th>
                  <th>O que</th>
                  <th>Por que</th>
                  <th>Onde</th>
                  <th>Quem</th>
                  <th>Como</th>
                  <th>Quando</th>
                  <th>Quanto</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {allAcoes.map(item => ( <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{objetivosById[String(item.objetivo_id)]?.nome || "-"}</td>
                    <td>{item.o_que}</td>
                    <td>{item.por_que || "-"}</td>
                    <td>{item.onde || "-"}</td>
                    <td>{item.quem || "-"}</td>
                    <td>{item.como || "-"}</td>
                    <td>{item.quando || "-"}</td>
                    <td>{item.quanto || "-"}</td>
                    <td>{statusLabels[item.status] || item.status || "-"}</td>
                  </tr>
                ))}
                {allAcoes.length === 0 ? ( <tr><td colSpan="10">Sem ações cadastradas.</td></tr>
                ) : null}
              </tbody>
            </table>
          </article>

          <article className="plan-admin-card">
            <h3>Indicadores</h3>
            <table className="plan-view-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Ação</th>
                  <th>Nome</th>
                  <th>Classificação</th>
                  <th>Valor</th>
                  <th>DNA</th>
                </tr>
              </thead>
              <tbody>
                {indicadores.map(item => ( <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{acoesById[String(item.acao_id)]?.o_que || item.acao_nome || "-"}</td>
                    <td>{item.nome}</td>
                    <td>{item.classificacao || "-"}</td>
                    <td>{formatValor(item.valor_texto, item.valor_numerico)}</td>
                    <td>{item.dna || "-"}</td>
                  </tr>
                ))}
                {indicadores.length === 0 ? ( <tr><td colSpan="6">Sem indicadores cadastrados.</td></tr>
                ) : null}
              </tbody>
            </table>
          </article>

          <article className="plan-admin-card">
            <h3>Metas</h3>
            <table className="plan-view-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Indicador</th>
                  <th>Meta</th>
                  <th>Valor</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {metas.map(item => ( <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{indicadoresById[String(item.indicador_id)]?.nome || item.indicador_nome || "-"}</td>
                    <td>{item.nome}</td>
                    <td>{formatValor(item.valor_texto, item.valor_numerico)}</td>
                    <td>{statusLabels[item.status] || item.status || "-"}</td>
                  </tr>
                ))}
                {metas.length === 0 ? ( <tr><td colSpan="5">Sem metas cadastradas.</td></tr>
                ) : null}
              </tbody>
            </table>
          </article>

          <article className="plan-admin-card">
            <h3>Diagnósticos</h3>
            <table className="plan-view-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Título</th>
                  <th>Descrição</th>
                </tr>
              </thead>
              <tbody>
                {diagnosticos.map(item => ( <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.titulo}</td>
                    <td>{item.descricao}</td>
                  </tr>
                ))}
                {diagnosticos.length === 0 ? ( <tr><td colSpan="3">Sem diagnósticos cadastrados.</td></tr>
                ) : null}
              </tbody>
            </table>
          </article>

          <article className="plan-admin-card">
            <h3>Riscos</h3>
            <table className="plan-view-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Objetivo</th>
                  <th>Identificação</th>
                  <th>Causa</th>
                  <th>Probabilidade</th>
                  <th>Impacto</th>
                  <th>Prevenção</th>
                  <th>Contingência</th>
                </tr>
              </thead>
              <tbody>
                {riscos.map(item => ( <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{objetivosById[String(item.objetivo_id)]?.nome || "-"}</td>
                    <td>{item.identificacao}</td>
                    <td>{item.causa}</td>
                    <td>{formatProbabilidadeLabel(item.probabilidade)}</td>
                    <td>{formatImpactoLabel(item.impacto)}</td>
                    <td>{item.prevencao}</td>
                    <td>{item.contingencia}</td>
                  </tr>
                ))}
                {riscos.length === 0 ? ( <tr><td colSpan="8">Sem riscos cadastrados.</td></tr>
                ) : null}
              </tbody>
            </table>
          </article>

          <article className="plan-admin-card">
            <h3>Overview</h3>
            <div className="plan-badges">
              {badges.length > 0 ? badges.map(badge => ( <span key={badge} className="plan-badge">{badge}</span>
              )) : <span className="plan-badge">Sem badges por enquanto</span>}
            </div>
            <ul>
              <li>{allAcoes.length} ações totais</li>
              <li>{allAcoes.filter(acao => isConcluida(acao.status)).length} ações concluídas</li>
              <li>{metas.filter(meta => isConcluida(meta.status)).length}/{metas.length} metas concluídas</li>
            </ul>
          </article>
        </section>
      )}
    </main>
  );
}


